export default "__VITE_ASSET__8ab21f74__"